module.exports = __webpack_public_path__ + "static/media/heart28.42ba5ff5.svg";